module.exports = __webpack_public_path__ + "static/media/circle_icon.cab45f9b.svg";